<template>
  <admin-layout title="Vídeos" menu="Vídeos">
    <title>VÍDEOS</title>
    <div class="row">
      <div class="col-lg-12 col-xs-12">
        <div>
          <div class="row">
            <div class="col-lg-2 col-xs-12">
              <div class="form-group color-dark-purple mb-0">
                <h3>VÍDEOS</h3>
              </div>
            </div>
            <div class="col-lg-10"></div>
          </div>
          <div class="row">
            <div class="col-lg-2"></div>
            <div class="col-lg-5 col-xs-12">
              <ul
                class="nav hide nav-tabs block_info_white"
                id="myTab"
                role="tablist"
              >
                <li class="nav-item mr-5">
                  <a
                    @click="changeStatus(false)"
                    class="nav-link p-1 nav-link-custom active"
                    id="videos-tab"
                    data-toggle="tab"
                    href="#videos"
                    role="tab"
                    aria-controls="videos"
                    aria-selected="true"
                  >
                    <b>VÍDEOS</b>
                  </a>
                </li>
                <li class="nav-item mr-5">
                  <a
                    @click="changeStatus(true)"
                    class="nav-link nav-link-custom p-1"
                    id="apply-tab"
                    data-toggle="tab"
                    href="#apply"
                    role="tab"
                    aria-controls="apply"
                    aria-selected="false"
                  >
                    <b>APLICAÇÕES</b>
                  </a>
                </li>
              </ul>
            </div>
            <div class="col-lg-2"></div>
            <div class="col-lg-3 col-xs-12">
              <div
                class="form-group mb-0 has-search d-flex justify-content-end"
                style="margin-left: -3px"
              >
                <div>
                  <span
                    class="fa fa-search ml-2 mt-2 mr-3 form-control-feedback"
                  ></span>
                </div>
                <input
                  type="text"
                  v-model="search"
                  v-on:keyup.enter="searchVideos"
                  class="form-control no_border"
                />
              </div>
              <div class="pt-2 right">
                <span class="mr-2">
                  <b>TOTAL</b>
                </span>
                <span >
                  <b>{{ totalVideos }}</b>
                </span>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-xs-12">
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="videos"
            role="tabpanel"
            aria-labelledby="videos-tab"
          >
            <div class="row">
              <div class="col-lg-12" style="overflow-x: auto">
                <div class="table-responsive mt-3">
                  <table class="table_jovool">
                    <thead class="headerTable">
                      <tr class="text-center">
                        <td>IMAGEM</td>
                        <td class="center" style="min-width: 200px">
                          NOME
                          <OrderTable field="candidate_name" entity="video" />
                        </td>
                        <td class="center">
                          CONTATO
                          <OrderTable field="candidate_email" entity="video" />
                        </td>
                        <td class="center">
                          VAGA
                          <OrderTable field="job_title" entity="video" />
                        </td>
                        <td class="center">
                          PERGUNTA
                          <OrderTable field="title" entity="video" />
                        </td>
                        <td class="center">
                          SCORE
                          <OrderTable field="score" entity="video" />
                        </td>

                        <td class="center">
                          DATA
                          <OrderTable
                            field="created_at"
                            pre_order="desc"
                            entity="video"
                          />
                        </td>

                        <td>VÍDEO</td>
                      </tr>
                    </thead>
                    <tbody class="position-relative">
                      <tr
                        v-for="(apply, index) in videos"
                        :key="apply.id"
                        :class="{ 'content-loading': loading }"
                      >
                        <td>
                          <div
                            class="avatar_thumb pointer"
                            @click="
                              showApply(apply.id, apply.candidate_id, index)
                            "
                          >
                            <img :src="apply.image" />
                          </div>
                        </td>

                        <td class="center">
                          <span class="d-inline-block text-truncate">{{
                            apply.candidate_name
                          }}</span>
                        </td>
                        <td class="center">
                          <span
                            class="d-inline-block text-truncate"
                            id="email"
                            @click="copyEmail(apply.candidate_email)"
                            >{{
                              apply.candidate_email != ""
                                ? apply.candidate_email
                                : ""
                            }}</span
                          >
                          <br v-if="apply.candidate_mobile_phone" />
                          <span
                            v-if="apply.candidate_mobile_phone"
                            class="d-inline-block text-truncate"
                            id="phone"
                            @click="copyPhone(apply.candidate_mobile_phone)"
                            >{{
                              apply.candidate_mobile_phone != ""
                                ? apply.candidate_mobile_phone
                                : ""
                            }}</span
                          ><br />
                        </td>
                        <td class="center">
                          <span
                            class="d-inline-block text-truncate"
                            style="max-width: 150px"
                            >{{ apply.job_title }}</span
                          >
                        </td>
                        <td class="center">
                          <span
                            class="d-inline-block text-truncate"
                            style="max-width: 100px"
                            :title="apply.title"
                            v-html="apply.title"
                            >"{{ apply.title }}"</span
                          >
                        </td>
                        <td>
                          <StarRating
                            class="center ajust_star"
                            active-color="#9472F8"
                            :read-only="true"
                            :rating="
                              parseInt(apply.score) ? parseInt(apply.score) : 0
                            "
                            v-bind:max-rating="5"
                            v-bind:star-size="20"
                          ></StarRating>
                        </td>

                        <td class="center">
                          {{ formattedDate(apply.created_at) }}
                        </td>
                        <td class="center">
                          <p
                            @click="
                              showApply(apply.id, apply.candidate_id, index)
                            "
                            class="pt-4 pointer color-primary"
                          >
                            <i class="fas f25 color-primary fa-file-alt"></i>
                          </p>
                        </td>
                      </tr>
                      <div
                        class="center position-absolute loading-gif"
                        :class="{ 'd-none': !loading || firstLoad }"
                      >
                        <img src="/images/loading.gif" alt="loading-gif" />
                      </div>
                    </tbody>
                  </table>
                </div>
                <v-pagination
                  v-model="currentPage"
                  :page-count="pageCount"
                  class="justify-content-center"
                  :class="firstLoad ? 'd-none' : 'd-flex'"
                  :classes="bootstrapPaginationClasses"
                ></v-pagination>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          ></div>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import moment from "moment";
import StarRating from "vue-star-rating";
import OrderTable from "components/OrderTable.vue";
import VideoShow from "@/Recruiters/Videos/Show.vue";
import vPagination from "vue-plain-pagination";
import ApplyShow from "@/Recruiters/Applies/Show.vue";
export default {
  components: { OrderTable, StarRating, VideoShow, vPagination, ApplyShow },
  data: () => ({
    search: "",
    order: "",
    field: "",
    applies: [],
    videos: [],
    firstLoad: true,
    loading: false,
    totalVideos: 0,
    currentPage: 1,
    pageCount: 1,
    bootstrapPaginationClasses: {
      ul: "pagination",
      li: "page-item",
      liActive: "active",
      liDisable: "disabled",
      button: "page-link",
    },
  }),
  mounted() {
    eventBus.$on("orderColumnvideo", (fields) => {
      this.field = fields.field;
      this.order = fields.order;
      this.searchVideos();
    });
    this.searchVideos();
  },
  watch: {
    currentPage: function () {
      this.searchVideos();
    },
  },
  methods: {
    showApply(apply_id, candidate_id, index) {
      this.$modal.show(
        ApplyShow,
        {
          current: this.videos[index].id,
          apply_id: this.videos[index].apply_id,
          candidate_id: this.videos[index].candidate_id,
          applies: this.videos,
          job_id: this.videos[index].job_id,
          job_name: this.videos[index].job_title,
          user_manager: false,
          recruiter_id: this.videos[index].recruiter_id,
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.searchVideos();
          },
        }
      );
    },
    copyEmail(email) {
      const texto = email;
      let input = document.createElement("input");
      input.value = texto;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.onCopyEmail();
    },
    copyPhone(phone) {
      const texto = phone;
      let input = document.createElement("input");
      input.value = texto;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.onCopyPhone();
    },
    onCopyEmail: function (e) {
      this.$toast.success("Email copiado com sucesso");
    },
    onCopyPhone: function (e) {
      this.$toast.success("Telefone copiado com sucesso");
    },
    showVideo(answer_id, index) {
      this.$modal.show(
        VideoShow,
        {
          index: index,
          videos: this.videos,
          answer_id: answer_id,
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.searchVideos();
          },
        }
      );
    },
    formattedDate(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    searchVideos() {
      let params = {};

      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      }
      params["search"] = this.search;
      if (this.search == "") {
        params["search"] = "*";
      }
      this.loading = true;
      axios
        .get(`/recruiters/videos/search/${this.currentPage}`, {
          params: params,
        })
        .then((response) => {
          // if (!this.deleted) {
          this.videos = response.data.videos;
          this.totalVideos = response.data.total_videos;
          this.pageCount = Math.ceil(this.totalVideos / 10);
          this.firstLoad = false;
          this.loading = false;
          return;
          // }
          // this.jobs_deleted = response.data.jobs;
        });
    },
  },
};
</script>
